<div class="position-relative">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <div class="operation-by-plate-container d-flex flex-wrap">
        <p class="title-operation col-12">{{ title }}</p>
        <p class="subtitle-operation col-12">
            Ingrese la placa del vehículo y los filtros para {{ actionLabel }} sus servicios.
        </p>

        <mat-form-field appearance="outline" class="col-12">
            <mat-label>Placa del vehículo<span class="asterisk">*</span></mat-label>
            <input matInput appLicensePlate type="text" placeholder="Ej: ABC123" maxlength="7"
                [formControl]="licensePlate">
            <mat-error *ngIf="licensePlate?.errors?.required">
                {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
            <mat-error *ngIf="licensePlate?.errors?.minlength">
                La placa debe tener al menos 4 caracteres
            </mat-error>
            <mat-error *ngIf="licensePlate?.errors?.maxlength">
                La placa no puede tener más de 7 caracteres
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-12 col-md-6">
            <mat-label>
                Desde
                <span class="optional" *ngIf="!includesApproved">(opcional)</span>
                <span class="asterisk" *ngIf="includesApproved">*</span>
            </mat-label>
            <input matInput [matDatepicker]="picker" readonly placeholder="Selecciona una fecha"
                [formControl]="finishDate" (click)="picker.open()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="finishDate?.errors?.required && includesApproved">
                {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
            <mat-hint>Se incluirán los servicios de esa fecha en adelante.</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-12 col-md-6">
            <mat-label>Servicios a incluir<span class="asterisk">*</span></mat-label>
            <mat-select [formControl]="scope">
                <mat-option *ngFor="let option of scopeOptions" [value]="option.value">{{ option.label }}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-12" *ngIf="includesRejected">
            <mat-label>Motivo de rechazo<span class="optional">(opcional)</span></mat-label>
            <input matInput type="text" placeholder="Motivo con el que fueron rechazados"
                [formControl]="rejectionReason">
            <mat-hint>Solo se podrán aprobar los servicios rechazados cuyo motivo de rechazo coincida con el
                ingresado.</mat-hint>
        </mat-form-field>

        <div class="button-container col-12">
            <button mat-raised-button color="primary" class="button-width-auto bg-color-primary" (click)="search()">
                Buscar servicios
            </button>
        </div>

        <div class="results-container col-12" *ngIf="searched">
            <div class="result-summary">
                <span class="result-chip available">Disponibles: {{ availableList.length }}</span>
                <span class="result-chip unavailable">Deshabilitados: {{ unavailableList.length }}</span>
                <span class="result-chip total">Encontrados: {{ totalFound }}</span>
            </div>

            <div class="alert alert-warning m-0 mt-3 d-flex align-items-center justify-content-center" role="alert"
                *ngIf="!totalFound">
                <i class="fas fa-exclamation-triangle mr-2"></i>
                <span>No se encontraron servicios para la placa con los filtros seleccionados.</span>
            </div>

            <div class="result-block" *ngIf="availableList.length">
                <p class="result-title available-title">
                    <i class="fas fa-check-circle mr-1"></i>
                    Servicios disponibles para {{ actionLabel }}
                </p>
                <p class="result-detail">{{ getConsecutives(availableList) }}</p>
            </div>

            <div class="result-block" *ngIf="unavailableList.length">
                <p class="result-title unavailable-title">
                    <i class="fas fa-times-circle mr-1"></i>
                    Servicios deshabilitados
                </p>
                <ul class="result-list">
                    <li *ngFor="let cargo of unavailableList">
                        <strong>{{ cargo.consecutive }}</strong>
                        <span *ngIf="cargo.errorMessage"> - {{ cargo.errorMessage }}</span>
                    </li>
                </ul>
            </div>
        </div>

        <div class="button-container col-12">
            <button mat-raised-button color="primary" class="button-width-auto bg-color-primary" *ngIf="canContinue"
                (click)="continue()">
                Continuar
            </button>
        </div>
    </div>
</div>